import React from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const testimonials = [
  {
    quote:
      'LiveFunnel has completely transformed how we manage our leads. Our conversion rates have increased by 45% since we started using their platform.',
    author: 'Sarah Johnson',
    role: 'Marketing Director, AutoNation',
    stars: 5,
    image: '/images/testimonial-1.jpg',
  },
  {
    quote:
      "The analytics and reporting features alone are worth the investment. We've been able to optimize our marketing spend and see exactly where our best leads are coming from.",
    author: 'Michael Chen',
    role: 'Sales Manager, Penske Automotive',
    stars: 5,
    image: '/images/testimonial-2.jpg',
  },
  {
    quote:
      "Customer support is exceptional. Any time we've had questions or needed help, the LiveFunnel team has been quick to respond and incredibly helpful.",
    author: 'Emily Rodriguez',
    role: 'Dealership Owner, Rodriguez Auto Group',
    stars: 5,
    image: '/images/testimonial-3.jpg',
  },
];

const Testimonials = () => {
  return (
    <section className="py-[100px] bg-white" id="testimonials">
      <div className="container mx-auto px-4">
        <div className="text-center mb-[60px]">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            Trusted by Top Automotive Brands
          </h2>
          <p className="text-lg text-gray max-w-[700px] mx-auto">
            Don't just take our word for it. Here's what our customers have to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-[30px] hover:shadow-xl hover:-translate-y-2.5 transition-all duration-300"
            >
              <div className="text-yellow-400 mb-4 flex">
                {[...Array(testimonial.stars)].map((_, i) => (
                  <FaStar key={i} className="w-5 h-5" />
                ))}
              </div>
              <FaQuoteLeft className="text-primary-light/50 text-4xl mb-6" />
              <p className="text-gray italic mb-6">"{testimonial.quote}"</p>
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full bg-primary-light/20 overflow-hidden mr-4">
                  <div className="w-full h-full flex items-center justify-center text-primary font-semibold">
                    {testimonial.author.charAt(0)}
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-dark">{testimonial.author}</h4>
                  <p className="text-sm text-gray">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-[60px] flex flex-wrap justify-center items-center gap-8">
          <img
            src="/images/logo-1.png"
            alt="AutoNation Logo"
            className="h-8 opacity-50 hover:opacity-100 transition-opacity"
          />
          <img
            src="/images/logo-2.png"
            alt="Penske Logo"
            className="h-8 opacity-50 hover:opacity-100 transition-opacity"
          />
          <img
            src="/images/logo-3.png"
            alt="AutoNation Logo"
            className="h-8 opacity-50 hover:opacity-100 transition-opacity"
          />
          <img
            src="/images/logo-4.png"
            alt="Lithia Motors Logo"
            className="h-8 opacity-50 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
